module.exports = __webpack_public_path__ + "static/media/video-01-tt.b5c79693.webm";